import type { RootState } from '@/store/rootReducer';

export const selectExternalUsers = (state: RootState) => state.externalUsers.users;

export const selectExternalUsersLoaded = (state: RootState) => state.externalUsers.isLoaded;

export const selectExternalUserDeleting = (state: RootState) => state.externalUsers.isDeleting;

export const selectExternalUsersError = (state: RootState) => state.externalUsers.error;

export const selectExternalUsersInvitedByMeOnly = (state: RootState) =>
  state.externalUsers.invitedByMeOnly;
